import React from 'react';

export const Apps = (props) => (
  <svg
    fill="none"
    height="16"
    viewBox="0 0 17 16"
    width="17"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <line
      stroke="#2F1359"
      x1="2.74364"
      x2="13.8306"
      y1="8.37181"
      y2="3.15442"
    />
    <line
      stroke="#2F1359"
      x1="3.12295"
      x2="14.2099"
      y1="8.35272"
      y2="12.2658"
    />
    <circle
      className="apps-icon-circle"
      cx="14.0434"
      cy="2.95652"
      fill="white"
      r="2.45652"
      stroke="#2F1359"
    />
    <circle
      className="apps-icon-circle"
      cx="2.95652"
      cy="8.17527"
      fill="white"
      r="2.45652"
      stroke="#2F1359"
    />
    <circle
      className="apps-icon-circle"
      cx="14.0434"
      cy="12.0854"
      fill="white"
      r="2.45652"
      stroke="#2F1359"
    />
  </svg>
);
